import {useLocation, Navigate, Outlet} from 'react-router-dom'

const Redirect = ({route}) => {
  const location = useLocation()

  if (location.pathname === '/auth')
    return <Navigate replace to={route} />
  else
    return <Outlet />
}

export default Redirect
